module.exports = __webpack_public_path__ + "static/img/nb__about@2x.f66531f0.png";